import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { Container, Row, Col } from "react-bootstrap";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable";
import { commonSelectProps, currentDate, datetime, exportToExcel, generatelargePdf, generatePdf } from "../utils/commonFunctions";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";import Select from 'react-select';
import KpiService from "../../Services/KpiService";
export default function DistrictLevelKpiProgressReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [distEnb, setDistEnb] = useState(false); const [distlist, setDistrictList] = useState(); const [Periodicitylist, setPeriodicitylist] = useState(); const [Yearlist, setYearlist] = useState(); const [Categorylist, setCategorylist] = useState(); const [searchText, setSearch] = useState(""); const [Id, setId] = useState(); const [Periodicid, setperiodicId] = useState(); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [Deptlist, setDeptlist] = useState([]); const [Distname, setDistname] = useState(); const [Deptname, setDeptname] = useState(); const [uniqueDepartments, setuniqueDepartments] = useState(); const [uniqueDistricts, setuniqueDistricts] = useState(); const [selectedDistrict, setselectedDistrict] = useState(); const [selecteddept, setselecteddept] = useState(); const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); const [years, setyears] = useState(); const [categorys, setcategorys] = useState(); const [selectedperiodicity, setselectedperiodicity] = useState(); const [selectedyear, setselectedyear] = useState(); const [selectedcategory, setselectedcategory] = useState(); const [districts, setdistricts] = useState();
  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid"); let district = localStorage.getItem("districtid"); let mandal = localStorage.getItem("mandalid"); let deptId = localStorage.getItem("deptid"); let SectariatName = localStorage.getItem("SectariatName");
 
  useEffect(() => {
    if(["111","113","114"].includes(roleid)){perioicitylist(deptId)}
    datetime(setcurrentdate, setcurrenttime);
  }, []);
  const formik = useFormik({
    initialValues: { userId: "", district_id: "", mandal_id: "",department_id: !["116","119","117"].includes(roleid) ? deptId : "", periodic_id: "", year: "", date: "", Indicators: [{ indicator_id: "", entry_value: "" }], remarks: "" },
    onSubmit: (values) => {},
  });
  const periodicityMap = {  monthly: { label: "MONTHLY", value: "6" }, quarterly: { label: "QUARTERLY", value: "7" },half_yearly: { label: "HALFYEARLY", value: "5" }, annually: { label: "ANNUALLY", value: "3" }, bi_annual: { label: "BIENNIAL", value: "8" }, five_years: { label: "FIVE-YEARS", value: "2" }};
  const perioicitylist = (dept) => {
    if (dept === "0") {
           const AllOptions = Object.keys(periodicityMap).map((key) => ({ label: periodicityMap[key].label, value: periodicityMap[key].value, }));

      setPeriodicitylist(AllOptions);
      return;
    }
  else{
    let paramss = { userId: username, deptId: dept, mandal: "No", district: "Yes", state: "No", secretariat: "No", };
    KpiService.getperiodicityStatusForAchievementsEntry(paramss).then((res) => {
      if (res.data) {
        if (res.data.SCODE === "01") { const apiData = res.data.SDESC[0];
          // const optionss = Object.keys(periodicityMap).filter((key) => apiData[key] > 0).map((key) => ( <option key={periodicityMap[key].value} value={periodicityMap[key].value}> {periodicityMap[key].label} </option> ));
                     const optionss = Object.keys(periodicityMap) .filter((key) => apiData[key] > 0) .map((key) => periodicityMap[key]);

          setPeriodicitylist(optionss);
        } else { showAlertMessage(res.data.SDESC, "warning"); }
      }
    });
  }
  };

  React.useEffect(() => {
    
    if (roleid === "111" || roleid === "113"  || roleid === "117" || roleid === "119" ) { setDistEnb(true);
      formik.setFieldValue("district_id", district);
     }
    if (roleid === "116") { setDistEnb(false); }
    let params = { district_id: district };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
      }
    });
    formik.setFieldValue("mandal_id", mandal);
  }, []);

  useEffect(() => {
    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        setdistricts(res17.data);
        let options = res17.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
        setDistrictList([ { id: "all", value: "All" }, ...(res17.data ?? []) ]);
      }
    });
    let params = { userId: username };
    MasterService.getDeptartments(params).then((res) => {
      if (res.data) {
        let options = res.data?.SDESC.map((item, i) => { return ( <option key={i} value={item.dept_id}> {item.dept_name} </option> ); });
        setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]);
      }
    });

   
  }, []);
  const MandalDropdown = (idd) => { formik.setFieldValue("periodic_id", ""); formik.setFieldValue("year", ""); formik.setFieldValue("date", ""); formik.setFieldValue("category", ""); };
  const Emptyfields = () => { formik.setFieldValue("periodic_id", ""); formik.setFieldValue("year", ""); formik.setFieldValue("category", ""); };
  const YearData = (idd) => {
    setYearlist([]); setEntrydataEnb(false); formik.setFieldValue("year", ""); formik.setFieldValue("date", ""); formik.setFieldValue("category", ""); if (!idd) { return; }
    setperiodicId(idd);
    setId("");
    let params = { userId: username, periodicityId: idd };
    KpiService.KpiperiodicYears(params).then((res20) => {
      let res = res20.data.SDESC.yearsList;
      if (res20.data) {
        setyears(res20.data.SDESC.yearsList);
        let options = res.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
        setYearlist(options);
      }
    });
    setYearlist([]);
  };
  const Categorydata = (idd) => {
    let missingFields = [];
    if (!formik.values.district_id) missingFields.push("District"); if (!formik.values.department_id) missingFields.push("HOD Name"); if (!idd) missingFields.push("Year");
    if (missingFields.length > 0) {
      const errorMessage = `Please Select Required Field${missingFields.length > 1 ? "s" : ""}: ${missingFields.join(", ")}.`;
      if (errorMessage) {
        showAlertMessage(errorMessage, "warning");
        return;
      }
    }
    setCategorylist([]); formik.setFieldValue("category", ""); formik.setFieldValue("date", ""); const selectedYear = idd;
    setId(selectedYear);
    if (roleid === "114" || roleid === "116") {
      const filterdistrict = districts?.find((item) => item.id === formik.values.district_id);
      setDistname(filterdistrict?.value);
    } else {
      setDistname(localStorage.getItem("districtname"));
    }
    const selectedKey = Object.keys(periodicityMap).find((key) => periodicityMap[key].value === formik.values.periodic_id);
    setselectedperiodicity(selectedKey ? periodicityMap[selectedKey].label : "");
    const filteryear = years?.find((item) => item.id === idd);
    setselectedyear(filteryear?.value);
    setselectedcategory(null);

    if (["1", "2", "3", "8"].includes(Periodicid)) {
      const params = { userId: username, districtId: (roleid === "119" || roleid === "117" )? district : formik.values.district_id, mandalId: "0", periodicityId: formik.values.periodic_id, year: idd, headId: "0", deptId: !["116","119","117"].includes(roleid)? deptId : formik.values.department_id };
      fetchEntryData(params);
    } else {
      const params = { userId: username, periodicityId: Periodicid };
      KpiService.KpiperiodicYears(params).then((res) => {
        const response = res.data.SDESC.headList;
        setcategorys(response);
        if (response) {
          const options = response?.map((item, i) => ( <option key={i} value={item.id}> {item.value} </option> ));
          setCategorylist(options);
        } else {
          setCategorylist([]);
        }
      });
    }
  };
  const getEntrydata = (idd) => {
    const filtercategory = categorys.find((item) => item.id === parseInt(idd));
    setselectedcategory(filtercategory?.value);
    let missingFields = [];
    if (!formik.values.district_id) missingFields.push("District"); if (!formik.values.department_id) missingFields.push("HOD Name"); if (!formik.values.year) missingFields.push("Year"); if (!idd) missingFields.push("Category");
    if (missingFields.length > 0) {
      const errorMessage = `Please Select Required Field${missingFields.length > 1 ? "s" : ""}: ${missingFields.join(", ")}.`;
      if (errorMessage) {
        showAlertMessage(errorMessage, "warning");
        return;
      }
    }
    const params = { userId: username, districtId: (roleid === "119" || roleid === "117") ? district : formik.values.district_id, mandalId: "0", periodicityId: formik.values.periodic_id, year: formik.values.year, headId: idd, deptId: !["116","119","117"].includes(roleid)? deptId : formik.values.department_id };
    fetchEntryData(params);
  };

  const fetchEntryData = (params) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.getdistrictLevelKpiIndicaterEntryProgressReport(params).then((res) => {
        setselectedDistrict(formik.values.district_id);
        setselecteddept(formik.values.department_id);
        store.dispatch({ type: "HIDE_SPINNER" });
        if (res.data.SCODE === "02") {
          showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false);
        } else {
          if (res.data.SCODE === "01") {
            setEntrydataEnb(true);
            setEntrydata(res.data.SDESC);
            if (["119","117","116"].includes(roleid) ) {
              let dept = res.data.SDESC[0].dept_name;
              setDeptname(dept);
            } else {
              setDeptname(localStorage.getItem("deptcodeName"));
            }
            const uniqueDepartments = [...new Set(res.data.SDESC?.map((item) => item.dept_name))]; setuniqueDepartments(uniqueDepartments); const uniqueDistricts = [...new Set(res.data.SDESC?.map((item) => item.district_name))];
            setuniqueDistricts(uniqueDistricts); } else { showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false); }
        }
      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };

  const filteredData =
    searchText.length > 0 && EntryData?.length
      ? EntryData.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); }) );
        })
      : EntryData;
  const filteredDistricts = uniqueDistricts?.filter((district) => filteredData?.some((item) => item.district_name === district));

  const filteredDepartments = uniqueDepartments?.filter((dept) => filteredData?.some((item) => item.dept_name === dept));
  return (
    <>
      <Menubar />
      <Container fluid className="map-header1"> <div className="sa-title"> <h2> District Level Indicators Entry <span>Progress Report</span> </h2> </div> </Container>
      <Container fluid style={{ width: "87%" }} className="outer-page-content-container mt-3">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4">
              <Row>
                {(roleid !== "116" && roleid!=="119") && (
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                    <h5>Secretariat Name</h5>
                    <Field className="mb-3 form-control" type="text" name="dept_name" value={SectariatName} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }}></Field>
                  </Col>
                )}
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  <label className="mb-1 fw-bold"> HOD Name</label>
                  <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, isDisabled: !["116","119","117"].includes(roleid), extraOnChange: (option) => { perioicitylist(option ? option.dept_id : "");  Emptyfields(); } })} />
                  
                </Col>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label className="mb-1 fw-bold"> District </label> <span style={{ color: "red" }}> *</span>
<Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: distEnb, extraOnChange: (option) => {  MandalDropdown(option? option.id:""); Emptyfields();} })} />
                  
                </Col>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                  <label className="mb-1 fw-bold"> Periodicity </label> <span style={{ color: "red" }}> *</span><Select {...commonSelectProps({ name: "periodic_id", options: Periodicitylist, value: formik.values.periodic_id, optionValueKey: "value", optionLabelKey: "label", formik, isDisabled: false, extraOnChange: (option) => { YearData(option ? option.value : ""); } })} />
                  
                </Col>
                <>
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                    <label className="mb-1 fw-bold"> Year </label> <span style={{ color: "red" }}> *</span>
                    <Select {...commonSelectProps({ name: "year", options: years, value: formik.values.year, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => { Categorydata(option? option.id:"") } })} />
                    
                  </Col>
                  {(Periodicid === "5" || Periodicid === "6" || Periodicid === "7") && (
                    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                      <label className="mb-1 fw-bold"> Category </label> <span style={{ color: "red" }}> *</span>
                       <Select {...commonSelectProps({ name: "category", options: categorys, value: formik.values.category, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => { getEntrydata(option? option.id:"") } })} />
                      
                    </Col>
                  )}
                  {Periodicid === "4" && (Id === "2025" || Id === "2024") && (
                    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="mandal-select">
                      <label className="mb-1 fw-bold"> Date </label> <span style={{ color: "red" }}> *</span>
                      <Field className="mb-3 form-control" type="date" name="date" onChange={(e) => { getEntrydata(e.target.value); formik.handleChange(e); }} max={currentDate} controlId="formBasicEmail" style={{ fontWeight: "bold" }} />
                    </Col>
                  )}
                </>
              </Row>
            </div>
            <br />
            {entrydataEnb && (
              <>
                <Row>
                  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                    <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} >
                      <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
                      <input type="text" placeholder="Search " value={searchText} onChange={(event) => setSearch(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
                    </div>
                  </Col>
                  <Col className=" mb-2 ">
                    <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => { selectedDistrict === "all" && selecteddept === "0" ? generatelargePdf("#my-table", "DistrictLevelKPIIndicatorProgressReport") : generatePdf("#my-table", "DistrictLevelKPIIndicatorProgressReport",selectedDistrict === "all" && selecteddept !== "0" ? filteredDepartments.length * 3 + 2 : filteredDistricts.length * 3 + 2); }} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                    <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "DistrictLevelKPIIndicatorProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
                  </Col>
                </Row>
                <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-2 px-2 ">
                  <span className="style"> District Level Progress Report Of Year {selectedyear}</span> <br />
                  {selecteddept !== "0" && (
                    <>
                      <span className="style-1">HOD Name:</span> <span className="style-2">{Deptname}</span>
                    </>
                  )}
                  {selectedDistrict !== "all" && (
                    <>
                      <span className="style-1">District:</span> <span className="style-2">{Distname},</span>
                    </>
                  )}
                  <span className="style-1">Periodicity:</span> <span className="style-2">{selectedperiodicity}</span>
                  {selectedcategory && (
                    <>
                      <span className="style-1">Category:</span> <span className="style-2">{selectedcategory}</span>
                    </>
                  )}
                  <div className="text-end style-1">
                    Report On : {currentdate} {currenttime}
                  </div>
                </div>
                <div id="table-scroll" className="table-scroll">
                  <div className="table-wrap">
                    <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table">
                      <thead>
                        {entrydataEnb && (
                          <>
                            <tr className="text-center only-export">
                              <th colSpan={selectedDistrict === "all" && selecteddept !== "0" ? filteredDepartments.length * 3 + 2 : filteredDistricts.length * 3 + 2} style={{textAlign: "center" }}>
                                <span className="style"> District Level Progress Report Of Year {selectedyear}</span>
                              </th>
                            </tr>
                            <tr className="text-center only-export">
                              <th colSpan={selectedDistrict === "all" && selecteddept !== "0" ? filteredDepartments.length * 3 + 2 : filteredDistricts.length * 3 + 2} style={{textAlign: "center" }}>
                                {selecteddept !== "0" && (
                                  <>
                                    <span style={{ color: "black" }}>HOD Name:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Deptname},</span>
                                  </>
                                )}
                                {selectedDistrict !== "all" && (
                                  <>
                                    <span style={{ color: "black" }}>&nbsp;District:</span> &nbsp; <span style={{ color: "#FBB040" }}>{Distname},</span>
                                  </>
                                )}
                                <span style={{ color: "black" }}> &nbsp;Periodicity:</span> &nbsp; <span style={{ color: "#FBB040" }}>{selectedperiodicity}</span>
                                {selectedcategory && (
                                  <>
                                    <span style={{ color: "black" }}> ,&nbsp;Category:</span> &nbsp; <span style={{ color: "#FBB040" }}>{selectedcategory}</span>
                                  </>
                                )}
                              </th>
                            </tr>
                            <tr className="only-export">
                              <th colSpan={selectedDistrict === "all" && selecteddept !== "0" ? filteredDepartments.length * 3 + 2 : filteredDistricts.length * 3 + 2}>
                                <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div>
                              </th>
                            </tr>
                          </>
                        )}
                        <tr className="text-center">
                          <th rowSpan={2} className="sticky-col sticky-sno"> Sl.No. </th>
                          {selecteddept === "0" || selectedDistrict !== "all" ? ( <th rowSpan={2} className="sticky-col sticky-mandal"> HOD Name </th> ) : ( <th className="sticky-col sticky-mandal" rowSpan={2}> District </th> )}
                          {selectedDistrict === "all" && selecteddept !== "0" ? filteredDepartments.map((dept, idx) => ( <th key={idx} colSpan={3}> {dept} </th> )) : filteredDistricts.map((mandal, idx) => ( <th key={idx} colSpan={3}> {mandal} </th> ))}
                        </tr>
                        <tr>
                          {selectedDistrict === "all" && selecteddept !== "0" ? filteredDepartments.map((_, idx) => ( <React.Fragment key={idx}> <th>Mapped Indicators</th> <th>Initiated Indicators</th> <th>Status</th> </React.Fragment> )) : filteredDistricts.map((_, idx) => ( <React.Fragment key={idx}> <th>Mapped Indicators</th> <th>Initiated Indicators</th> <th>Status</th> </React.Fragment> ))}
                        </tr>
                        <tr>
                          {(() => {
                            let columnIndex = 1;
                            let columns = [];
                            columns.push( <th className="sticky-col sticky-sno" key={`col-${columnIndex}`}> {columnIndex++} </th> );
                            columns.push( <th className="sticky-col sticky-mandal" key={`col-${columnIndex}`}> {columnIndex++} </th> );
                            {
                              selectedDistrict === "all" && selecteddept !== "0"
                                ? filteredDepartments.forEach(() => {
                                    for (let i = 0; i < 3; i++) {
                                      columns.push(
                                        <th className={columnIndex === 1 ? "sticky-col sticky-sno" : columnIndex === 2 ? "sticky-col sticky-mandal" : ""} key={`col-${columnIndex}`}>
                                          {columnIndex++}
                                        </th>
                                      );
                                    }
                                  })
                                : filteredDistricts.forEach(() => {
                                    for (let i = 0; i < 3; i++) {
                                      columns.push(
                                        <th className={columnIndex === 1 ? "sticky-col sticky-sno" : columnIndex === 2 ? "sticky-col sticky-mandal" : ""} key={`col-${columnIndex}`}>
                                          {columnIndex++}
                                        </th>
                                      );
                                    }
                                  });
                            }
                            return columns;
                          })()}
                        </tr>
                      </thead>
                      <tbody>
                        {selectedDistrict === "all" && selecteddept !== "0"
                          ? filteredDistricts.map((district, index) => (
                              <tr key={index}>
                                <td className="sticky-col sticky-sno" style={{ textAlign: "center" }}> {index + 1} </td>
                                <td className="sticky-col sticky-mandal">{district}</td>
                                {filteredDepartments.map((dept, i) => {
                                  const matchedItem = filteredData.find((item) => item.district_name === district && item.dept_name === dept);
                                  return (
                                    <React.Fragment key={i}>
                                      <td className="text-end"> {matchedItem ? (matchedItem.dept_indicator_count !== 0 && matchedItem.dept_indicator_count !== null ? matchedItem.dept_indicator_count : "NA") : null} </td>
                                      <td className="text-end"> {matchedItem ? (matchedItem.saved_indicators !== 0 && matchedItem.saved_indicators !== null ? matchedItem.saved_indicators : "NA") : null} </td>
                                      <td className="text-center"> {matchedItem ? matchedItem.status : ""} </td>
                                    </React.Fragment>
                                  );
                                })}
                              </tr>
                            ))
                          : filteredDepartments.map((dept, index) => (
                              <tr key={index}>
                                <td style={{ textAlign: "center" }} className="sticky-col sticky-sno"> {index + 1} </td>
                                <td className="sticky-col sticky-mandal">{dept}</td>
                                {filteredDistricts.map((district, i) => {
                                  const matchedItem = filteredData.find((item) => item.district_name === district && item.dept_name === dept);
                                  return (
                                    <React.Fragment key={i}>
                                      <td style={{ textAlign: "right" }}> {matchedItem ? (matchedItem.dept_indicator_count !== 0 && matchedItem.dept_indicator_count !== null ? matchedItem.dept_indicator_count : "NA") : null} </td> <td style={{ textAlign: "right" }}> {matchedItem ? (matchedItem.saved_indicators !== 0 && matchedItem.saved_indicators !== null ? matchedItem.saved_indicators : "NA") : null} </td> <td style={{ textAlign: "center" }}> {matchedItem ? matchedItem.status : ""} </td>
                                    </React.Fragment>
                                  );
                                })}
                              </tr>
                            ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </Form>
        </FormikProvider>
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
